import React, { useState, useEffect } from "react"
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

export default function TimePick(props) {
  
    const [submittedDate, setSubmittedDate] = useState(props.date);

    const onChange = (date) => {
        setSubmittedDate(date);
        props.changeTime(date);
    };
    
    useEffect(() => {
        setSubmittedDate(props.date)
    }, [props.date])

    const CustomMultipleInput =({openCalendar, value}) => {
        return (
          <input
            onFocus={openCalendar}
            className = 'rmdp-input'
            style = {{
                'width': '400px',
                'marginLeft': '0'
            }}
            value={value}
            readOnly
          />
        )
    }

    return (
        <DatePicker 
            format="MM/DD/YYYY hh:mm A"
            onChange={(date) => {
                onChange(date);
            }}
            plugins={[
                <TimePicker hideSeconds />
            ]} 
            minDate={new Date()}
            value={submittedDate} 
            onClose = { () => { }}
            render={<CustomMultipleInput />}
        />
    )
}


// WEBPACK FOOTER //
// ./src/components/assignments/TimePicker.js